export const ClickThroughAttributionOptions = {
    1: '1 Day',
    7: '7 Days',
}

export const ViewThroughAttributionOptions = {
    0: "None",
    1: '1 Day',
}

/**
 * Meta restricts attribution windows based on optimization goal.
 * OFFSITE_CONVERSIONS / VALUE support wider windows (7-day click, 1-day view).
 * LINK_CLICKS / REACH / IMPRESSIONS only allow (1-day click, 0 view).
 */
export const AttributionByStrategy = {
    MAXIMIZE_CONVERSIONS:        { click_through: 7, view_through: 1 },
    MAXIMIZE_CONVERSION_VALUE:   { click_through: 7, view_through: 1 },
    MAXIMIZE_LINK_CLICKS:        { click_through: 1, view_through: 0 },
    MAXIMIZE_DAILY_UNIQUE_REACH: { click_through: 1, view_through: 0 },
    MAXIMIZE_IMPRESSIONS:        { click_through: 1, view_through: 0 },
};